import React from 'react'
import PropTypes from 'prop-types'
import ButtonWidget from 'widgets/ButtonWidget'
import PreviewWidget from 'widgets/PreviewWidget'
import FormWidget from 'widgets/FormWidget'
import ListWidget from 'widgets/ListWidget'

const WidgetTypes = {
  form: 'form',
  button: 'button',
  preview: 'preview',
  list: 'list'
}

const BookingWidget = ({ type, ...widgetConfig }) => {
  switch (type) {
    case WidgetTypes.preview:
      return <PreviewWidget {...widgetConfig} />
    case WidgetTypes.form:
      return <FormWidget {...widgetConfig} />
    case WidgetTypes.list:
      return <ListWidget {...widgetConfig} />
    case WidgetTypes.button:
    default:
      return <ButtonWidget {...widgetConfig} />
  }
}

BookingWidget.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(Object.values(WidgetTypes)),
  host: PropTypes.string
}

export default BookingWidget
